import React from 'react';
import './Upload.scss';
import { FaUpload } from "react-icons/fa";
import cards from './Json';

const Upload = () => {
  return (
    <div className="card-main">
      {cards.map((card) => (
        <div className="card" key={card.id}>
          <span><FaUpload /></span>
          <h3>{card.title}</h3>
          <p>{card.description}</p>
          <div className="bottom"></div>
        </div>
      ))}
    </div>
  );
};

export default Upload;
